import { AvatarProps } from '@mui/material';
import { InitialsAvatar } from 'components/InitialsAvatar';
import { FC } from 'react';

export const StoreAvatar: FC<
  AvatarProps & { storeName: string; storeId: string }
> = ({ storeName, storeId }) => {
  return <InitialsAvatar name={storeName} id={Number(storeId)} />;
};
